<div class="lang-switcher" role="group" [attr.aria-label]="'common.language' | t">
  <button
    type="button"
    class="lang-btn"
    [class.active]="lang() === 'en'"
    (click)="setLang('en')"
    [attr.aria-label]="'common.english' | t"
    [title]="'common.english' | t"
  >
    EN
  </button>
  <button
    type="button"
    class="lang-btn"
    [class.active]="lang() === 'es'"
    (click)="setLang('es')"
    [attr.aria-label]="'common.spanish' | t"
    [title]="'common.spanish' | t"
  >
    ES
  </button>
</div>
